import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { 
  Layout, Eye, Edit, Globe, 
  Smartphone, Zap, ArrowRight 
} from 'lucide-react';

const DigiWebsiteLanding = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <Layout className="w-8 h-8" />,
      title: "Visual Builder",
      description: "Drag-and-drop website builder with section-based editing"
    },
    {
      icon: <Edit className="w-8 h-8" />,
      title: "Easy Customization",
      description: "Customize colors, fonts, and content without coding"
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: "Mobile Responsive",
      description: "Websites that look perfect on all devices automatically"
    },
    {
      icon: <Globe className="w-8 h-8" />,
      title: "Custom Domain",
      description: "Publish your website with your own custom domain"
    },
    {
      icon: <Eye className="w-8 h-8" />,
      title: "Instant Preview",
      description: "See your changes live as you build your website"
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: "Fast & Reliable",
      description: "Lightning-fast loading speeds with secure hosting"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-slate-50">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Digi<span className="text-indigo-600">Website</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Build Professional Websites in Minutes - No Coding Required
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Button
              onClick={() => navigate('/auth')}
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-6 text-lg rounded-full"
            >
              Start Building <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => navigate('/auto-website')}
              variant="outline"
              className="px-8 py-6 text-lg rounded-full border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-50"
            >
              Quick Website
            </Button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="text-indigo-600 mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-indigo-600 to-indigo-700 rounded-3xl p-12 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Build Your Website?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Join businesses creating professional websites with ease
          </p>
          <Button
            onClick={() => navigate('/auth')}
            className="bg-white text-indigo-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-full font-semibold"
          >
            Start Free Trial
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DigiWebsiteLanding;